// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"140cc66a","496":"8cbd160f","770":"ee3ff284","800":"c8664894","915":"3eeb2549"}[chunkId] + ".chunk.js";
};